import React from "react";
import PropTypes from "prop-types";
import { UiIcon } from "../../Layouts/Icon";
import { CATEGORY_ICONS } from "../../constants";
import { iconLabel } from "../../utils/svgIcon";
import { CategoryNavSkeleton } from "../Skeleton";

/**
 * Category filter: a sidebar on desktop and a scrolling chip row on smaller screens.
 * Categories toggle on and off (several can be shown at once); "All icons" clears them.
 * A selected category swaps its icon for a ticked checkbox.
 */
export const CategoryNav = ({ categories, onToggle, onShowAll }) => {
  const anySelected = categories.some((category) => category.checked);
  const total = categories.reduce((sum, category) => sum + category.total, 0);

  return (
    <nav className="category-nav" aria-label="Icon categories">
      <ul>
        <li>
          <button
            type="button"
            className={`category-nav__item${anySelected ? "" : " is-active"}`}
            aria-pressed={!anySelected}
            onClick={onShowAll}
          >
            <UiIcon name="options" />
            All icons
            <span className="category-nav__count">{total || ""}</span>
          </button>
        </li>
        {categories.length === 0 ? <CategoryNavSkeleton /> : null}
        {categories.map((category, index) => (
          <li key={category.cat_name}>
            <button
              type="button"
              className={`category-nav__item${category.checked ? " is-active" : ""}`}
              aria-pressed={!!category.checked}
              onClick={() => onToggle(index)}
            >
              {category.checked ? (
                <span className="category-nav__check" aria-hidden="true">
                  <UiIcon name="check" />
                </span>
              ) : (
                <UiIcon
                  name={CATEGORY_ICONS[category.cat_name] || CATEGORY_ICONS.default}
                />
              )}
              <span className="category-nav__label">{iconLabel(category.cat_name)}</span>
              <span className="category-nav__count">{category.total}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

CategoryNav.propTypes = {
  categories: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onShowAll: PropTypes.func.isRequired,
};

export default CategoryNav;
